import React from 'react';
import compose from 'lodash.flowright';

import CardTemplateCreatorMasterView from '../views/template-creator/CardTemplateCreatorMasterView';
import CardGroupCreate from '../views/template-creator/CardCreate';
import RequireAuth from '../../../components/routing/RequireAuth';
import RequireRole from '../../../components/routing/RequireRole';
import ACCOUNT_ROLES from '../../../constants/account-roles';
import AccountCardPrint from '../views/AccountCardPrint';
import AccountCardPublicConfigurator from '../views/AccountCardPublicConfigurator';
import AccountDownloadsConfigurator from '../../pro/views/Account/AccountDownloadsConfigurator';
import SaveTheDateConfigurator from '../views/SaveTheDateConfigurator';
import RedirectWithStatus from '../../../components/routing/RedirectWithStatus';
import EventCollagesConfigurator from '../views/EventCollagesConfigurator';

const RequireAdminRole = RequireRole([ACCOUNT_ROLES.ADMINISTRATOR]);

const routes = [
  {
    path: '/cards',
    exact: true,
    component: () => <RedirectWithStatus status={301} to="/cards/create" />,
  },
  {
    path: '/cards/templates',
    exact: false,
    component: compose(
      RequireAuth,
      RequireAdminRole,
    )(CardTemplateCreatorMasterView),
    routes: [
      {
        path: '/cards/templates/create',
        exact: true,
        component: CardGroupCreate,
      },
    ],
  },
  {
    path: '/cards/downloads-configurator/:hierarchyItemId',
    exact: true,
    component: compose(RequireAuth)(AccountDownloadsConfigurator),
  },
  {
    path: '/cards/print/:accountCardId/:side',
    exact: true,
    component: compose(RequireAuth)(AccountCardPrint),
  },
  {
    path: '/cards/create/:cardCategoryId?',
    exact: true,
    component: AccountCardPublicConfigurator,
  },
  {
    path: '/cards/save-the-date/:albumFolderId',
    exact: true,
    component: compose(RequireAuth)(SaveTheDateConfigurator),
  },
  {
    path: '/cards/event-collages/:albumFolderId',
    exact: true,
    component: compose(RequireAuth)(EventCollagesConfigurator),
  },
];

export default routes;
